import React, { Component } from "react";
import "./styles.css";
import Modal from "../modal";
import Util from "../../classes/util";
import moment from "moment";
import { Link } from "react-router-dom";

const estadoInicial = {};

class ModalHistorico extends Component {
  state = {
    ...estadoInicial,
  };

  componentDidMount = async () => {};

  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={() => this.props.onClose()}
        className={this.props.className ? this.props.className : null}
        styles={this.props.styles ? this.props.styles : null}
      >
        <div className="modal_historico">
        <button style={{color:"#DE3338", textDecorationThickness:"30%", margin:"10px", border:"0px", background:"white"}} onClick={() => this.props.onClose()}>X</button>
          <div className="modal_historico_titulo"></div>
          {this.props.lancamentos.map((lancto) => {
            if (lancto.tipo === "PAGAMENTO") {
              return (
                <div className="modal_historico_lancamento">
                  {this.props.voucher && (
                    <span>
                      {lancto.usuarioNome} - {lancto.produtoNome}
                    </span>
                  )}
                  {!this.props.voucher && (
                    <span>
                      {lancto.unidadeNome} -{" "}
                      <b>R${Util.formatarDinheiro(lancto.valor)}</b>
                    </span>
                  )}

                  <div className="modal_historico_lancamento_tipo">
                    <span>
                      {this.props.voucher ? "RECEBIDO" : "TRANSFERIDO"}
                    </span>
                    <span>
                      {moment(lancto.data).format("DD/MM/YYYY HH:mm:ss")}
                    </span>
                  </div>

                  {this.props.voucher && (
                    <span>
                      {lancto.unidadeNome} -{" "}
                      <b>R${Util.formatarDinheiro(lancto.valor)}</b>
                    </span>
                  )}
                  {!this.props.voucher && (
                    <span>
                      {lancto.usuarioNome} - {lancto.produtoNome}
                    </span>
                  )}
                </div>
              );
            } else if (lancto.tipo === "DEVOLUCAO") {
              return (
                <div className="modal_historico_lancamento">
                  {this.props.voucher && (
                    <span>
                      <b>R${Util.formatarDinheiro(lancto.valor)}</b> -{" "}
                      {lancto.usuarioNome} - {lancto.produtoNome}
                    </span>
                  )}
                  {!this.props.voucher && <span>{lancto.unidadeNome}</span>}

                  <div className="modal_historico_lancamento_tipo">
                    <span>
                      {this.props.voucher ? "TRANSFERIDO" : "DEVOLVIDO"}
                    </span>{" "}
                    <span>
                      {moment(lancto.data).format("DD/MM/YYYY HH:mm:ss")}
                    </span>
                  </div>

                  {!this.props.voucher && (
                    <span>
                      <b>R${Util.formatarDinheiro(lancto.valor)}</b> -{" "}
                      {lancto.usuarioNome} - {lancto.produtoNome}
                    </span>
                  )}
                  {this.props.voucher && <span>{lancto.unidadeNome}</span>}
                </div>
              );
            } else if (lancto.tipo === "COBRANCA") {
              return (
                <div className="modal_historico_lancamento">
                  <span>
                    {lancto.usuarioNome} - {lancto.produtoNome}
                  </span>

                  <div className="modal_historico_lancamento_tipo">
                    <span>UTILIZADO</span>
                    <span>
                      {moment(lancto.data).format("DD/MM/YYYY HH:mm:ss")}
                    </span>
                  </div>

                  <span>
                    <b>R${Util.formatarDinheiro(lancto.valor)}</b>
                  </span>
                </div>
              );
            }
            else if (lancto.tipo === "DESCONTO") {
              return (
                <div className="modal_historico_lancamento">
                  <span>
                    ADMINISTRAÇÃO - COBRANÇA DE PROGRAMAÇÃO
                  </span>

                  <div className="modal_historico_lancamento_tipo">
                    <span>COBRADO - ADM</span>
                    <span>
                      {moment(lancto.data).format("DD/MM/YYYY HH:mm:ss")}
                    </span>
                  </div>

                  <span>
                    <b>R${Util.formatarDinheiro(lancto.valor)}</b>
                  </span>
                </div>
              );
            }
            else if (lancto.tipo === "LIBERACAO") {
              return (
                <div className="modal_historico_lancamento">
                  <span>
                    ADMINISTRAÇÃO - LIBERAÇÃO DE SALDO
                  </span>

                  <div className="modal_historico_lancamento_tipo">
                    <span>LIBERADO - ADM</span>
                    <span>
                      {moment(lancto.data).format("DD/MM/YYYY HH:mm:ss")}
                    </span>
                  </div>

                  <span>
                    <b>R${Util.formatarDinheiro(lancto.valor)}</b>
                  </span>
                </div>
              );
            }
          })}
        </div>
      </Modal>
    );
  }
}

export default ModalHistorico;
